import React from 'react';

import { SubHeaderOptions } from 'constants/index';
import SubHeader from 'components/common/SubHeader';
import StitchLetterList from 'components/stitchletter/_list';

const LetterList = () => {
  return (
    <>
      <SubHeader options={SubHeaderOptions} selected="스티치 레터" />
      <StitchLetterList />
    </>
  );
};

export default LetterList;
